export default {
  title: "Bitácora de Geolocalización"
  , tabla: {
    clave: {
      label: "Clave"
      , th: "Clave"
    }
    , fecha: {
      label: "Fecha"
      , th: "Fecha"
    }
    , proceso: {
      label: "Proceso"
      , th: "Proceso"
    }
    , servicio: {
      label: "Servicio"
      , th: "Servicio"
    }
    , url: {
      label: "URL"
      , th: "URL"
    }
    , direccion: {
      label: "Dirección"
      , th: "Dirección"
    }
    , altura: {
      label: "Altura"
      , th: "Altura"
    }
    , vendor: {
      label: "Vendor"
      , th: "Vendor"
    }
    , respuesta: {
      label: "Respuesta"
      , th: "Respuesta"
    }
    , se: {
      label: "SE"
      , th: "SE"
    }
    , base: {
      label: "Base"
      , th: "Base"
    }
    , baseDetalle: {
      label: "Base Detalle"
      , th: "Base Detalle"
    }
    , username: {
      label: "Usuario"
      , th: "Usuario"
    }
  }
  , filtros: {
    fecha: "Fecha"
    , proceso: "Proceso"
    , servicio: "Servicio"
    , se: "SE"
    , direccion: "Dirección"
    , altura: "Altura"
    , vendor: "Vendor"
    , username: "Usuario"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bitacoras/geolocalizacion.js